/**
 * Utilitários para manipulação dinâmica de favicon e título da aba no navegador.
 */

export function updateFavicon(iconUrl: string | null): void {
  if (typeof document === 'undefined') return

  const defaultFavicon = '/favicon.ico'
  const targetUrl = iconUrl && iconUrl.trim() !== '' ? iconUrl.trim() : defaultFavicon

  let linkIcon = document.querySelector<HTMLLinkElement>("link[rel~='icon']")
  let linkShortcut = document.querySelector<HTMLLinkElement>("link[rel='shortcut icon']")

  if (!linkIcon) {
    linkIcon = document.createElement('link')
    linkIcon.rel = 'icon'
    document.head.appendChild(linkIcon)
  }
  linkIcon.href = targetUrl

  if (linkShortcut) {
    linkShortcut.href = targetUrl
  }
}

export function updateDocumentTitle(brandName: string | null, sectionTitle?: string): void {
  if (typeof document === 'undefined') return

  const cleanBrand = brandName?.trim()
  const cleanSection = sectionTitle?.trim()

  if (cleanBrand) {
    if (cleanSection) {
      document.title = `${cleanBrand} - ${cleanSection}`
    } else {
      document.title = `${cleanBrand} - Seven Analytics`
    }
  } else {
    if (cleanSection) {
      document.title = `Seven Analytics - ${cleanSection}`
    } else {
      document.title = 'Seven Analytics'
    }
  }
}

export function resetFaviconAndTitle(): void {
  updateFavicon(null)
  updateDocumentTitle(null)
}
